export default __webpack_public_path__ + "static/media/euro.f78f1b1a.svg";